import { render, staticRenderFns } from "./SubscriptionsAdminView.vue?vue&type=template&id=2d13796f&scoped=true&"
import script from "./SubscriptionsAdminView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsAdminView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsAdminView.vue?vue&type=style&index=0&id=2d13796f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13796f",
  null
  
)

export default component.exports